// extracted by mini-css-extract-plugin
export default {"loader":"Item_Loader_loader__cRc3S","load8":"Item_Loader_load8__YTX0z"};